import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  ListElemText,
  ListItemBox,
  ListItemBoxCell,
  ListItemBoxHeader,
  ListItemBoxRow,
  ListItemBoxText,
  ListItemCont,
  maskName,
  useTranslation,
  convertAmount,
  exchangeAmountByRate,
  getAmountWithCurrency,
} from '@pascal/pascal-core';

import { globalTranslationKeys } from '../../../enums';
import { marketTypes } from '../../../helpers/constants';

export const CurrentAndTopWinnersItem = observer(({ betData }) => {
  const t = useTranslation();

  const {
    additionalParams: { marketType, number },
  } = betData;

  return (
    <ListItemCont>
      <ListItemBox>
        <ListItemBoxHeader>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={t(globalTranslationKeys.PlayerId)} />
          </ListItemBoxCell>
          <ListItemBoxCell size='small'>
            <ListItemBoxText text={maskName(betData.playerExternalId)} size='big' />
          </ListItemBoxCell>
        </ListItemBoxHeader>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={t(globalTranslationKeys.BetType)} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListElemText
              title={`${
                marketType === marketTypes.Under
                  ? t(globalTranslationKeys.Under)
                  : t(globalTranslationKeys.Over)
              } ${number}`}
            >
              <i
                className={`ui-lib-over-arrow-2 ${
                  marketType === marketTypes.Under ? 'under' : 'over'
                }`}
              />
              {number}
            </ListElemText>
          </ListItemBoxCell>
        </ListItemBoxRow>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={t(globalTranslationKeys.Bet)} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText
              size='big'
              text={getAmountWithCurrency({
                amount: convertAmount(exchangeAmountByRate(betData).amount),
                isShowRealCurrency: true,
              })}
            />
          </ListItemBoxCell>
        </ListItemBoxRow>
        <ListItemBoxRow>
          <ListItemBoxCell size='big'>
            <ListItemBoxText size='big' text={t(globalTranslationKeys.Win)} />
          </ListItemBoxCell>
          <ListItemBoxCell>
            <ListItemBoxText
              className='win-color'
              size='big'
              text={getAmountWithCurrency({
                amount: convertAmount(exchangeAmountByRate(betData).winAmount),
                isShowRealCurrency: true,
              })}
            />
          </ListItemBoxCell>
        </ListItemBoxRow>
      </ListItemBox>
    </ListItemCont>
  );
});
